<template>
  <div class="m-container">
    <m_header></m_header>
    <m_menu></m_menu>
    <div class="m-body">
      <el-container class="m-title-box">
        <div class="m-title">
          <div class="m-title-t">用户管理</div>
          <span class="m-title-s">对用户信息管理等操作</span>
        </div>
        <div class="m-tips">
          <i class="el-icon-warning"></i>使用提示
        </div>
      </el-container>
      <div class="m-search-wrap">
        <el-form :inline="true" :model="searchForm" ref="searchForm">
          <el-form-item label="省-合作商:" size="mini">
            <el-select v-model="searchForm.proviceCoopId" filterable placeholder="请选择" @change="changeProvice">
              <el-option
                v-for="(item, index) in proviceCoopList"
                :key="index"
                :label="item.label + '-' + item.phone"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="市-合作商:" size="mini">
            <el-select v-model="searchForm.cooperatorId" filterable placeholder="请选择" @change="changeCoop">
              <el-option
                v-for="(item, index) in coopList"
                :key="index"
                :label="item.cooperatorName + '-' + item.phone"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="团队长:" size="mini">
            <el-select v-model="searchForm.teamId" filterable placeholder="请选择"
                       :disabled="searchForm.cooperatorId === ''" v-loading="teamLoading" @change="changeTeam">
              <el-option
                v-for="(item, index) in teamCoopList"
                :key="index"
                :label="item.label + '-' + item.phone"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="业务员:" size="mini">
            <el-select v-model="searchForm.salesmanId" filterable placeholder="请选择" :disabled="searchForm.teamId === ''" v-loading="salesmanLoading">
              <el-option
                v-for="(item, index) in salesmanCoopList"
                :key="index"
                :label="item.label + '-' + item.phone"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="用户电话:" size="mini">
            <el-input type="text" v-model="searchForm.phone"  placeholder="搜索用户电话" />
          </el-form-item>
          <el-form-item label="用户所在地:" size="mini">
            <el-input type="text" v-model="searchForm.cityName"  placeholder="搜索用户所在地区" />
          </el-form-item>
            <el-form-item label="时间范围:" size="mini">
              <el-date-picker
                v-model="pickerTime"
                type="datetimerange"
                :default-time="['00:00:00','23:59:59']"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @change="onPickerChange"
                :picker-options="pickerOptions">
              </el-date-picker>
            </el-form-item>
          <el-form-item style="margin-left: 30px;" size="mini">
            <el-button type="primary" @click="listData()">搜索</el-button>
            <el-button type="primary" plain @click="resetForm()">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="m-table">
        <el-container class="m-table-head">
          <div class="m-table-title">
            <i class="el-icon-s-opportunity"></i>用户列表
          </div>
          <div class="m-table-btn">
            <div class="m-total">
              <div class="m-total-item">
                <div>用户总数：{{ total }} 人</div>
                <div class="m-total-item-tip">未选择查询时间段时，数据均为累积总数</div>
              </div>
<!--              <div class="m-total-item m-total-new">本月新增：{{ newUser }} 人</div>-->
            </div>
          </div>
        </el-container>
        <el-table :data="list" v-loading="isLoading" style="width: 100%;margin-bottom: 20px;" border size="mini">
          <el-table-column prop="phone" label="电话" width="110" align="center" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="nickname" label="用户昵称" width=""></el-table-column>
          <el-table-column prop="cityName" label="用户地区" width=""></el-table-column>
          <el-table-column prop="cooperatorName" label="所属服务商" width=""></el-table-column>
          <el-table-column prop="teamName" label="所属团队长" width=""></el-table-column>
          <el-table-column prop="salesmanName" label="所属业务员" width=""></el-table-column>
          <el-table-column prop="loginIp" label="登录ip" width="130" align="center"></el-table-column>
          <el-table-column prop="loginDate" label="登录时间" width="" align="center"></el-table-column>
          <el-table-column prop="createDate" label="创建时间" width="" align="center"></el-table-column>
          <el-table-column prop="updateDate" label="修改时间" width="" align="center"></el-table-column>
          <el-table-column label="操作" width="120" align="center">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click="openForm(scope.row.id)" plain>详细资料</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="searchForm.pageNo"
          :page-size="10"
          layout="total, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <el-dialog title="详细信息" :visible.sync="openState" @close='closeDialog' width="950px" :close-on-click-modal="false">
      <div v-loading="formLoading" class="m-user-open">
        <div class="m-user-open-item">
          <label>用户昵称：</label>
          <div class="m-user-open-cont">{{form.nickname}}</div>
        </div>
        <div class="m-user-open-item">
          <label>手机号：</label>
          <div class="m-user-open-cont" style="font-weight: bold;">{{form.phone}}</div>
        </div>
        <div class="m-user-open-item">
          <label>用户性别：</label>
          <div v-if="form.sex === '1'" class="m-user-open-cont">男</div>
          <div v-else-if="form.sex === '0'" class="m-user-open-cont">女</div>
          <div v-else class="m-user-open-cont">-</div>
        </div>
        <div class="m-user-open-item">
          <label>用户职业：</label>
          <div class="m-user-open-cont">{{form.occupation}}</div>
        </div>
        <div class="m-user-open-item">
          <label>用户生日：</label>
          <div class="m-user-open-cont">{{form.birthday}}</div>
        </div>
        <div class="m-user-open-item">
          <label>学习目标：</label>
          <div class="m-user-open-cont">{{form.target}}</div>
        </div>
        <div class="m-user-open-item">
          <label>所属地区：</label>
          <div class="m-user-open-cont">{{form.cityName}}</div>
        </div>
        <div class="m-user-open-item">
          <label>所属服务商：</label>
          <div class="m-user-open-cont">{{form.cooperatorName}}</div>
        </div>
        <div class="m-user-open-item" style="width: 100%;">
          <label>详细地址：</label>
          <div class="m-user-open-cont">{{form.address}}</div>
        </div>
      </div>
      <div slot="footer" class="dialog-foote" style="text-align: center;">
        <el-button @click="openState = false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'appUser',
  data () {
    return {
      openState: false,
      formLoading: false,
      isLoading: true,
      specialLoading: false,
      teamLoading: false,
      salesmanLoading: false,
      list: [],
      coopList: [], // 市级合作商选项
      proviceCoopList: [], // 省级合作商选项
      specialCoopList: [], // 省特派员选项
      teamCoopList: [], // 团队长选项
      salesmanCoopList: [], // 业务员选项
      total: 0,
      form: {
        id: '',
        userId: '',
        phone: '',
        cooperatorId: '',
        userIcon: '',
        cityName: '',
        nickname: '',
        sex: '',
        birthday: '',
        address: '',
        occupation: '',
        target: '',
        dream: '',
        qrCodePath: '',
        shareUserId: '',
        loginIp: '',
        loginDate: '',
        createDate: '',
        updateDate: ''
      },
      searchForm: {
        cityName: '',
        proviceCoopId: '',
        cooperatorId: '',
        specialId: '',
        teamId: '',
        salesmanId: '',
        phone: '',
        startDate: '',
        endDate: '',
        pageNo: 1
      },
      pickerTime: '',
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      }
    }
  },
  methods: {
    onPickerChange (e) {
      let startDate = new Date(e[0])
      let endDate = new Date(e[1])
      this.searchForm.startDate = startDate.getFullYear() +
        '-' + (startDate.getMonth() < 10 ? '0' + (startDate.getMonth() + 1) : (startDate.getMonth() + 1)) +
        '-' + (startDate.getDate() < 10 ? '0' + startDate.getDate() : startDate.getDate())
      this.searchForm.endDate = endDate.getFullYear() +
        '-' + (endDate.getMonth() < 10 ? '0' + (endDate.getMonth() + 1) : (endDate.getMonth() + 1)) +
        '-' + (endDate.getDate() < 10 ? '0' + endDate.getDate() : endDate.getDate())
    },
    handleCurrentChange (val) {
      this.searchForm.pageNo = val
      this.listData()
    },
    resetForm () {
      this.searchForm = {
        cityName: '',
        proviceCoopId: '',
        cooperatorId: '',
        specialId: '',
        teamId: '',
        salesmanId: '',
        phone: '',
        startDate: '',
        endDate: '',
        pageNo: 1
      }
      this.pickerTime = ''
      this.listData()
      this.changeProvice()
    },
    closeDialog () {
      this.form = {
        id: '',
        userId: '',
        phone: '',
        cooperatorId: '',
        userIcon: '',
        cityName: '',
        nickname: '',
        sex: '',
        birthday: '',
        address: '',
        occupation: '',
        target: '',
        dream: '',
        qrCodePath: '',
        shareUserId: '',
        loginIp: '',
        loginDate: '',
        createDate: '',
        updateDate: ''
      }
      this.openState = false
      this.formLoading = false
    },
    openPopup () {
      this.openState = true
    },
    openForm (id) {
      let _this = this
      _this.openState = true
      _this.formLoading = true
      this.$axios.post('/app/user/form', {id: id})
        .then((res) => {
          if (res.status === 200) {
            _this.form = res.data
            _this.isLoading = false
            _this.formLoading = false
          } else {
            _this.$message.error(res.msg)
          }
        })
    },
    // 用户列表
    listData () {
      let _this = this
      this.isLoading = true
      _this.list = []
      this.$axios.post('/app/user/list', _this.searchForm)
        .then((res) => {
          _this.list = res.data.rows
          _this.total = res.data.total
          _this.isLoading = false
        })
    },
    // 省级变化时，市，团，员，全清空
    changeProvice () {
      this.searchForm.cooperatorId = ''
      this.searchForm.teamId = ''
      this.searchForm.salesmanId = ''
      this.coopList = []
      this.teamCoopList = []
      this.salesmanCoopList = []
      this.listCoopData()
    },
    // 市级变化时，团，员，清空
    changeCoop () {
      this.searchForm.teamId = ''
      this.searchForm.salesmanId = ''
      this.teamCoopList = []
      this.salesmanCoopList = []
      this.teamCoopData(this.searchForm.cooperatorId)
    },
    // 团级变化时，员，清空
    changeTeam () {
      this.searchForm.salesmanId = ''
      this.salesmanCoopList = []
      this.salesmanCoopData(this.searchForm.teamId)
    },
    // 省级合作商下拉选项
    proviceCoopData () {
      this.$axios.post('/dropDownList/proviceCoopList')
        .then((res) => {
          this.proviceCoopList = res.data
        })
    },
    // 市级合作商下拉选项
    listCoopData () {
      this.$axios.post('/dropDownList/coopList', {proviceCoopId: this.searchForm.proviceCoopId})
        .then((res) => {
          this.coopList = res.data
        })
    },
    // 团队长下拉选项
    teamCoopData (cooperatorId) {
      this.teamLoading = true
      this.$axios.post('/dropDownList/teamCoopList', {cooperatorId: cooperatorId})
        .then((res) => {
          this.teamCoopList = res.data
          this.teamLoading = false
        })
    },
    // 业务员下拉选项
    salesmanCoopData (teamId) {
      this.salesmanLoading = true
      this.$axios.post('/dropDownList/salesmanCoopList', {teamId: teamId})
        .then((res) => {
          this.salesmanCoopList = res.data
          this.salesmanLoading = false
        })
    }
  },
  mounted () {
    this.listData()
    this.listCoopData()
    this.proviceCoopData()
  }
}
</script>

<style scoped src="../../assets/css/user.css"></style>



// WEBPACK FOOTER //
// src/components/user/User.vue